import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "attendance",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-schoolSetup" */ "./components"),
        import(/* webpackChunkName: "admin-schoolSetup" */ "./modules/Module"),
      ]).then(([importedModule0, importedModule1]) => {
        const { AttendanceSetup } = importedModule0;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "attendanceSetup",
          reducer,
        });
        return AttendanceSetup;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
